const lang = {
  member_info: '会員情報',
  user_info: '利用者情報',
  change_icon: 'アイコン編集',
  username: '利用者名',
  mail_address: 'メールアドレス',
  phone_number: '電話番号',
  company_name: '会社名',
  group_name: '部署名',
  mail: 'メール',
  address: 'アドレス'
}

export default lang;



// WEBPACK FOOTER //
// ./src/lang/ja/pages/cl102.js